/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { getLandingContainer } from "../../../utils/getLandingContainer"

/* Protopia Ecosystem component */
export interface ILandingConsoleHandlerProps {
   console_width: number
   setConsoleWidth: (width: number) => void
   updateConsoleWidth: ( ) => void
}
const LandingConsoleHandler = (props: ILandingConsoleHandlerProps): JSX.Element => {
    const ref = useRef(null) 
    const {width}       = useScreenSize()
    
    const isMove        = useSyncState<boolean>( false )
    const isClick       = useSyncState<boolean>( false )

    const onMouseDown = (evt: MouseEvent) => { 
        isClick.set( true ) 
        const landing = getLandingContainer()
        const consoleContent = document.querySelector(".landing-console-panel-content")!
        landing.style.userSelect ="none" 
        consoleContent.style.userSelect ="none" 
        landing.style.pointerEvents ="none" 
        consoleContent.style.pointerEvents ="none" 
    }
    const onMouseUp = () => {
        isClick.set(false) 
        isMove.set(false) 
        const landing = getLandingContainer()
        const consoleContent = document.querySelector(".landing-console-panel-content")!
        landing.style.userSelect ="auto" 
        consoleContent.style.userSelect ="auto" 
        landing.style.pointerEvents ="auto" 
        consoleContent.style.pointerEvents ="auto" 
        props.updateConsoleWidth()
    }
    const onMouseMove = (evt: MouseEvent) => {  
        if(!isClick.get()) return
        let x = width - evt.clientX 
        if(x > 500) x = 500
        if(x < 200) x = 200
        props.setConsoleWidth(x)
        
    }
    useEffect(() => { 
        const handler = (ref.current! as any)
        handler.addEventListener("mousedown", onMouseDown)
        document.addEventListener("mouseup", onMouseUp)
        document.addEventListener("mousemove", onMouseMove)

        return () => { 
            handler.removeEventListener("mousedown", onMouseDown)
            document.removeEventListener("mouseup", onMouseUp)
            document.removeEventListener("mouseup", onMouseMove)
        }
    }, [])
    
    return <div 
        className='pe-landing-console-handler-container' 
        ref={ref} 
        style={{ 
            right: props.console_width,
            backgroundColor: isClick.get() ? "var(--force-dark-color)" : undefined
        }}
    />
}
export default LandingConsoleHandler